import { render, staticRenderFns } from "./WorkerReportManagerWrapper.vue?vue&type=template&id=39319454&"
import script from "./WorkerReportManagerWrapper.vue?vue&type=script&lang=js&"
export * from "./WorkerReportManagerWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports